import { ReactNode } from 'react';

import { ReactNodeBundleBot } from './ReactNodeBundleBot';
import { StringArrayBundleBot } from './StringArrayBundleBot';
import './styles.scss';

interface BundleBotProps {
  children?: ReactNode;
  text?: string[];
  onComplete?: () => void;
  className?: string;
}

const BundleBot = ({
  children,
  onComplete,
  className,
  text,
}: BundleBotProps) => {
  if (children) {
    return (
      <ReactNodeBundleBot onComplete={onComplete} className={className}>
        {children}
      </ReactNodeBundleBot>
    );
  }

  if (text) {
    return (
      <StringArrayBundleBot
        text={text}
        onComplete={onComplete}
        className={className}
      />
    );
  }

  return null;
};

export { BundleBot };
export {
  BundleBotHeading,
  BundleBotText,
  BundleBotBold,
  BundleBotLink,
} from './components';
